var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClassList},[_c('span',{staticClass:"prop-copy"},[_vm._v(_vm._s(_vm.valueProp.value_prop))]),_vm._v(" "),(_vm.hasSlicedCopy)?_c('span',{staticClass:"sliced-copy",domProps:{"innerHTML":_vm._s(_vm.getSlicedCopy)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }